import FormFields from "../core/SignUp-SignIn/FormFields";
import React from "react";
import { AccountSettingsFormData } from "../../hooks/useAccountSettings";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography
  } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { signUpFieldsList } from "../core/SignUp-SignIn/fieldsLists";

interface ProfileSectionProps {
  formData: AccountSettingsFormData;
  formErrors: Record<string, string>;
  isSaving: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSave: () => Promise<void>;
}

export default function ProfileSection({
  formData,
  formErrors,
  isSaving,
  onChange,
  onSave,
}: ProfileSectionProps) {
  // Pola do edycji danych profilu (bez emaila)
  const profileFields = signUpFieldsList
    .filter((f) => ["firstName", "lastName", "organizationName", "phoneNumber"].includes(f.name))
    .map((f) => ({ ...f, required: f.name !== "phoneNumber" }));

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
          Dane profilu
        </Typography>

        {/* Email - tylko do odczytu */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              name="email"
              label="E-mail"
              type="email"
              value={formData.email || ""}
              disabled
              size="small"
              helperText="Email nie może być zmieniony"
            />
          </Grid>
        </Grid>

        <FormFields
          fieldsList={profileFields as any}
          formData={formData}
          formErrors={formErrors}
          onChange={onChange}
          fieldDirection="row"
        />

        {/* Wyświetl błąd zapisu jeśli wystąpił */}
        {formErrors.save && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {formErrors.save}
          </Alert>
        )}

        {/* Sekcja faktury zintegrowana z danymi profilu */}
        <Box sx={{ mt: 4, pt: 3, borderTop: "1px solid #eee" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.isInvoiceNeeded || false}
                onChange={onChange}
                name="isInvoiceNeeded"
              />
            }
            label="Chcę podać dane do faktury dla organizatorów"
            sx={{ mb: 2 }}
          />


          {formData.isInvoiceNeeded && (
          <><Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
            Dane do faktury
          </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="invoiceName"
                  label="Nazwa firmy/instytucji"
                  type="text"
                  required
                  value={formData.invoiceName || ""}
                  onChange={onChange}
                  helperText={formErrors.invoiceName}
                  error={!!formErrors.invoiceName}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="invoiceTaxId"
                  label="NIP"
                  type="text"
                  required
                  value={formData.invoiceTaxId || ""}
                  onChange={onChange}
                  helperText={formErrors.invoiceTaxId}
                  error={!!formErrors.invoiceTaxId}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="invoiceStreet"
                  label="Ulica"
                  type="text"
                  required
                  value={formData.invoiceStreet || ""}
                  onChange={onChange}
                  helperText={formErrors.invoiceStreet}
                  error={!!formErrors.invoiceStreet}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  name="invoiceHouseNumber"
                  label="Numer domu"
                  type="text"
                  required
                  value={formData.invoiceHouseNumber || ""}
                  onChange={onChange}
                  helperText={formErrors.invoiceHouseNumber}
                  error={!!formErrors.invoiceHouseNumber}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  name="invoiceLocalNumber"
                  label="Numer lokalu"
                  type="text"
                  value={formData.invoiceLocalNumber || ""}
                  onChange={onChange}
                  helperText={formErrors.invoiceLocalNumber}
                  error={!!formErrors.invoiceLocalNumber}
                  size="small"
                />
              </Grid>
              <Grid item xs={4} sm={3}>
                <TextField
                  fullWidth
                  name="invoicePostalCode"
                  label="Kod pocztowy"
                  type="text"
                  required
                  value={formData.invoicePostalCode || ""}
                  onChange={onChange}
                  helperText={formErrors.invoicePostalCode}
                  error={!!formErrors.invoicePostalCode}
                  size="small"
                />
              </Grid>
              <Grid item xs={8} sm={3}>
                <TextField
                  fullWidth
                  name="invoiceCity"
                  label="Miasto"
                  type="text"
                  required
                  value={formData.invoiceCity || ""}
                  onChange={onChange}
                  helperText={formErrors.invoiceCity}
                  error={!!formErrors.invoiceCity}
                  size="small"
                />
              </Grid>
            </Grid>
            </>)}
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <LoadingButton variant="contained" onClick={onSave} loading={isSaving}>
            Zapisz dane
          </LoadingButton>
        </Box>
      </CardContent>
    </Card>
  );
}
